<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9996 2.39844C15.9213 2.39844 19.2856 4.77633 20.7321 8.16602C20.9163 8.5978 20.7156 9.098 20.2838 9.28223C19.8522 9.46615 19.3529 9.26543 19.1686 8.83398C17.98 6.04826 15.2166 4.09766 11.9996 4.09766C7.69734 4.09785 4.20978 7.58542 4.20959 11.8877C4.20959 14.8877 5.90541 17.4928 8.39417 18.7949C8.81003 19.0125 8.97096 19.5265 8.75354 19.9424C8.53594 20.3583 8.022 20.5193 7.60608 20.3018C4.57881 18.7179 2.51038 15.545 2.51038 11.8877C2.51056 6.64653 6.75846 2.39863 11.9996 2.39844Z"
      fill="white" />
    <path
      d="M18.733 17.7334C19.4327 17.7334 19.9996 18.3003 19.9996 19C19.9996 19.6997 19.4327 20.2666 18.733 20.2666C18.0333 20.2666 17.4665 19.6997 17.4664 19C17.4664 18.3003 18.0333 17.7334 18.733 17.7334Z"
      fill="white" />
    <path
      d="M18.6637 12.8799C18.9956 12.5482 19.533 12.5481 19.8649 12.8799C20.1967 13.2118 20.1966 13.7491 19.8649 14.0811L14.3365 19.6104C14.0047 19.942 13.4673 19.9418 13.1354 19.6104C12.8034 19.2784 12.8034 18.7401 13.1354 18.4082L18.6637 12.8799Z"
      fill="white" />
    <path
      d="M13.9996 12.4658C14.6993 12.4658 15.2672 13.0337 15.2672 13.7334C15.267 14.4329 14.6992 15 13.9996 15C13.3002 14.9998 12.7333 14.4328 12.733 13.7334C12.733 13.0338 13.3001 12.466 13.9996 12.4658Z"
      fill="white" />
  </svg>
</template>
